import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { mechanisms } from '../data/mechanisms';
export function ScienceSection() {
  return <section className="w-full bg-sand/50 py-16 sm:py-24" aria-labelledby="ciencia-title" data-id="element-293" data-mp="197wx8rczj9n8">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-294" data-mp="1963qlc2dgpf8">
        <Reveal data-id="element-295" data-mp="1e5opjmhjkxry">
          <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-296" data-mp="1e68895f0nq71">
            La ciencia del secuestro
          </p>
          <h2 id="ciencia-title" className="mt-4 max-w-3xl font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-[2.6rem]" data-id="element-297" data-mp="lic3ddfamrz6">
            Por qué tu cuerpo se está hinchando (y no es culpa tuya)
          </h2>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-ink/85 sm:text-lg" data-id="element-298" data-mp="v96yz8efj3xa">
            Tu abdomen abultado, tus ojos hinchados al despertar y esa fatiga que no se va con café
            no son fallas de tu voluntad. Son señales de{' '}
            <strong className="font-semibold text-bark" data-id="element-299" data-mp="2phzpfn4ema9">Secuestro Hormonal</strong>. Cuando el
            cortisol está crónicamente alto, tu cuerpo activa 3 mecanismos de defensa
            simultáneamente.
          </p>
        </Reveal>

        <div className="mt-14 space-y-12 lg:space-y-16" data-id="element-300" data-mp="6isde8yllgxz">
          {mechanisms.map((m, index) => <Reveal key={m.number} data-id="element-301" data-mp="2ii1ygs1dybq" data-mpi={index}>
              <article className={`grid items-center gap-8 lg:grid-cols-2 lg:gap-14 ${index % 2 === 1 ? 'lg:[&>figure]:order-2' : ''}`} data-id="element-302" data-mp="2hgqwcb0tbu0">
                <figure className="overflow-hidden rounded-2xl border border-bark/10 bg-cream shadow-soft" data-id="element-303" data-mp="3op6o7z1klas5">
                  <img src={m.image} alt={m.imageAlt} className="w-full object-cover" loading="lazy" data-id="element-304" data-mp="3jptzf8r51tmx" />
                </figure>

                <div data-id="element-305" data-mp="3fpju7yb67794">
                  <p className="text-xs font-semibold uppercase tracking-widest text-clay" data-id="element-306" data-mp="3fq35iw6bexe6">
                    {m.number}
                  </p>
                  <h3 className="mt-2 font-display text-2xl leading-snug text-bark sm:text-3xl" data-id="element-307" data-mp="1dxex88etdjrj">
                    {m.title}
                  </h3>
                  <p className="mt-4 text-base leading-relaxed text-ink/85" data-id="element-308" data-mp="37eb74jfxpv53">{m.intro}</p>
                  <ul className="mt-5 space-y-2.5" data-id="element-309" data-mp="3c7cmesk1zwp7">
                    {m.effects.map(effect => <li key={effect} className="flex gap-3 text-sm leading-relaxed text-ink/80" data-id="element-310" data-mp="2yfz75qt6hkzz">
                        <ArrowRightIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-311" data-mp="32fzxa8pn3kmv" />
                        {effect}
                      </li>)}
                  </ul>
                  <p className="mt-6 rounded-xl bg-bark px-5 py-4 text-sm font-medium leading-relaxed text-cream" data-id="element-312" data-mp="3v5yooarb3tup">
                    <span className="font-semibold uppercase tracking-wide text-cream/60" data-id="element-313" data-mp="3h4maa3rso0ax">
                      Resultado ·{' '}
                    </span>
                    {m.result}
                  </p>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}